import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = () => {
    const navItems = [
        {
            section: 'Main',
            items: [
                { path: '/', icon: 'bi-speedometer2', label: 'Dashboard', exact: true },
                { path: '/analytics', icon: 'bi-graph-up', label: 'Analytics' },
            ]
        },
        {
            section: 'User Management',
            items: [
                { path: '/users', icon: 'bi-people', label: 'App Users' },
                { path: '/admin-users', icon: 'bi-shield-check', label: 'Admin Users' },
                { path: '/sessions', icon: 'bi-clock-history', label: 'Active Sessions' },
            ]
        },
        {
            section: 'Content Management',
            items: [
                { path: '/articles', icon: 'bi-file-text', label: 'Articles' },
                { path: '/duas', icon: 'bi-book', label: 'Duas' },
                { path: '/insights', icon: 'bi-lightbulb', label: 'Daily Insights' },
                { path: '/categories', icon: 'bi-folder', label: 'Categories' },
            ]
        },
        {
            section: 'Engagement',
            items: [
                { path: '/notifications', icon: 'bi-bell', label: 'Send Notification' },
                { path: '/broadcasts', icon: 'bi-broadcast', label: 'Broadcast History' },
                { path: '/notification-templates', icon: 'bi-file-earmark-text', label: 'Templates' },
            ]
        },
        {
            section: 'Media & Resources',
            items: [
                { path: '/media', icon: 'bi-image', label: 'Media Library' },
                { path: '/contact', icon: 'bi-envelope', label: 'Contact Info' },
            ]
        },
        {
            section: 'Reports',
            items: [
                { path: '/reports', icon: 'bi-files', label: 'Generate Reports' },
            ]
        },
        {
            section: 'System',
            items: [
                { path: '/activity-log', icon: 'bi-clock-history', label: 'Activity Log' },
            ]
        },
    ];

    return (
        <div className="sidebar">
            <div className="sidebar-header">
                <div className="sidebar-logo">
                    <img 
                        src="/logo.png" 
                        alt="Nisa Care Logo"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            borderRadius: 'var(--radius-md)'
                        }}
                    />
                </div>
                <div>
                    <h1 className="sidebar-title">Nisa Care</h1>
                    <p className="sidebar-subtitle">ADMIN PANEL</p>
                </div>
            </div>

            <nav className="sidebar-nav">
                {navItems.map((section, idx) => (
                    <div key={idx} className="nav-section">
                        <div className="nav-section-title">{section.section}</div>
                        {section.items.map((item, itemIdx) => (
                            <NavLink
                                key={itemIdx}
                                to={item.path}
                                className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                                end={item.exact || item.path === '/'}
                            >
                                <i className={item.icon}></i>
                                <span>{item.label}</span>
                            </NavLink>
                        ))}
                    </div>
                ))}
            </nav>
        </div>
    );
};

export default Sidebar;